import React from 'react';
//import font from 'dseg/fonts/DSEG7-Classic/DSEG7Classic-BoldItalic.ttf';
import 'dseg/css/dseg.css';

const Clock = ({ minutes = 0, seconds = 0, size }) => {
  const minuteDigits = String(minutes).padStart(2, '0');
  const secondDigits = String(seconds).padStart(2, '0');
  const fontSizes = {
    small: '1em',
    big: '4em',
    massive: '8em',
  };
  const fontSize = fontSizes[size] || '2em';
  return (
    <div
      style={{
        fontFamily: 'DSEG7-Classic',
        fontSize,
        lineHeight: 1.2,
        fontWeight: 'bold',
        fontStyle: 'italic',
      }}
    >
      {minuteDigits}.{secondDigits}
    </div>
  );
};

export default Clock;



// WEBPACK FOOTER //
// ./src/components/Clock.js